function setPersistentCookie(name, value, days = 30) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    const expires = "; expires=" + date.toUTCString();
    document.cookie = name + "=" + (value || "") + expires + "; path=/; SameSite=Lax";
}

function getCookie(name) {
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for(let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}

function isInShopifyAdmin() {
    try {
        return window.top.location.hostname === 'admin.shopify.com';
    } catch (e) {
        console.warn("Could not access parent window location, assuming inside Shopify admin iframe.");
        return true;
    }
}

const newsletterPopupClosed = getCookie('newsletterPopupClosed');
const alreadySubscribedToNewsletter = getCookie('alreadySubscribedToNewsletter');

window.onload = function () {
    let openPopupTimeOut = null;

    if (
        !isInShopifyAdmin() &&
        (!newsletterPopupClosed || newsletterPopupClosed == "false") &&
        document.getElementsByClassName("subscribe-to-newsletter")[0].getAttribute("data-auto-show") != "false"
    ) {
        openPopupTimeOut = setTimeout(() => {
            document.querySelector(".subscribe-to-newsletter").classList.add("show");
        }, 5000);
    }

    document.getElementById("open-n-popup").onclick = function () {
        document.querySelector(".subscribe-to-newsletter").classList.add("show");
        if (openPopupTimeOut) {
            clearTimeout(openPopupTimeOut);
        }
    };

    document.getElementById("close-n-popup").onclick = function () {
        document.querySelector(".subscribe-to-newsletter").classList.remove("show");
        setPersistentCookie("newsletterPopupClosed", "true");
    };

    if (alreadySubscribedToNewsletter == "true") {
        const popup = document.querySelector(".subscribe-to-newsletter");
        popup.querySelector("h2").innerText = "You're already subscribed!";
        popup.querySelector("p").innerText = "You received a discount code in your email.";
        popup.querySelector("i").innerText = "CHECK INBOX";
        popup.querySelector("form").remove();
    }
};

const newsletterForm = document.getElementById("af-form-30617849").parentElement;
const newsletterApi = newsletterForm.getAttribute("data-api-url");

newsletterForm.onsubmit = async function (e) {
    e.preventDefault();
    newsletterForm.style.opacity = 0.7;
    newsletterForm.style.pointerEvents = "none";
    newsletterForm.parentElement.getElementsByClassName("error-info")[0].getElementsByTagName("p")[0].innerHTML = "";

    const email = newsletterForm.querySelectorAll("input[name='email']")[0];
    const cCode = newsletterForm.querySelectorAll("input[name='custom coupon']")[0];
    const meta_adtracking = newsletterForm.querySelectorAll("input[name='meta_adtracking']")[0];
    const meta_web_form_id = newsletterForm.querySelectorAll("input[name='meta_web_form_id']")[0];

    if (!meta_adtracking.value || !meta_web_form_id.value) {
        newsletterForm.parentElement.getElementsByClassName("error-info")[0].getElementsByTagName("p")[0].innerHTML =
            "There is a problem in your browser. Client Error";
        return;
    }

    const response = await fetch(newsletterApi, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            email: email.value,
            meta_adtracking: meta_adtracking.value,
            meta_web_form_id: meta_web_form_id.value,
        }),
    });

    const data = await response.json();

    if (response.status === 200) {
        const code = atob(data.c);
        cCode.value = code;
        setPersistentCookie("newsletterPopupClosed", "true");
        setPersistentCookie("alreadySubscribedToNewsletter", "true");

        // Show the discount code in the popup
        const popup = document.querySelector(".subscribe-to-newsletter");
        popup.querySelector("h2").innerText = "Here's your 10% OFF code!";
        popup.querySelector("p").innerText = "Use this code at checkout:";
        popup.querySelector("i").innerText = code;
        popup.querySelector("form").style.display = "none";
        popup.querySelector(".error-info").style.display = "none";

        // Submit to AWeber in background
        HTMLFormElement.prototype.submit.call(newsletterForm);
    } else {
        newsletterForm.parentElement.getElementsByClassName("error-info")[0].getElementsByTagName("p")[0].innerHTML = data.message;
    }

    newsletterForm.style.opacity = 1;
    newsletterForm.style.pointerEvents = "all";
};
